import React from 'react'

type IProps = {}

const DevPage: React.FC<IProps> = ({}) => {
    return <div>Dev1</div>
}

export default DevPage